/* eslint-disable react/jsx-no-target-blank */
import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import config from 'config';
import { Wrapper, MiniWrapper } from './styled';

function TPCarousel(props) {
  return (
    <div
      className={`trustpilot-widget ${props.className}`}
      data-locale="en-GB"
      data-template-id={props.templateId}
      data-businessunit-id={config.get('public.trustpilot.data_businessunit_id')}
      data-style-height="350px"
      data-style-width="100%"
      data-theme="light"
      data-stars="5"
      data-review-languages="en"
    >
      <a href="https://uk.trustpilot.com/review/fixter.co.uk" target="_blank" rel="noopener">
        Trustpilot
      </a>
    </div>
  );
}

TPCarousel.propTypes = {
  templateId: PropTypes.string.isRequired,
  className: PropTypes.string,
};

TPCarousel.defaultProps = {
  className: '',
};

function Trustpilot(props) {
  const { useMiniCarousel } = props.params;
  const instance = useRef(null);

  useEffect(() => {
    if (document) {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
      instance.current.appendChild(script);
    }
  }, []);

  return (
    <div ref={instance}>
      {useMiniCarousel === 'false' ? (
        <Wrapper>
          <TPCarousel className="full" templateId={config.get('public.trustpilot.carousel_template_id')} />
          <TPCarousel
            className="mini"
            templateId={config.get('public.trustpilot.mini_carousel_template_id')}
          />
        </Wrapper>
      ) : (
        <MiniWrapper>
          <TPCarousel templateId={config.get('public.trustpilot.mini_carousel_template_id')} />
        </MiniWrapper>
      )}
    </div>
  );
}

Trustpilot.propTypes = {
  params: PropTypes.object.isRequired,
};

export default Trustpilot;
